import { render, staticRenderFns } from "./SpinnerWheelContentTab.vue?vue&type=template&id=ca6bb94e&scoped=true&"
import script from "./SpinnerWheelContentTab.vue?vue&type=script&lang=js&"
export * from "./SpinnerWheelContentTab.vue?vue&type=script&lang=js&"
import style0 from "./SpinnerWheelContentTab.vue?vue&type=style&index=0&id=ca6bb94e&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ca6bb94e",
  null
  
)

export default component.exports